import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Link as MLink,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import {
  AccountTree,
  Article,
  AutoAwesome,
  BusinessCenter,
  ExpandMore,
  Hub,
  Insights,
  Launch,
  LightbulbOutlined,
  ManageSearch,
  Public,
  School,
  ScienceOutlined,
  WorkspacePremium,
} from '@mui/icons-material';
import { consultingOffers, pdiProjects } from '../data/pesquisaInovacao';

type PesquisaTab =
  | 'sobre'
  | 'politicas'
  | 'pesquisadores'
  | 'iniciacao'
  | 'linhas'
  | 'programas'
  | 'projetos-integradores'
  | 'inovacao'
  | 'publicacoes'
  | 'infraestrutura'
  | 'rede-impacto'
  | 'transparencia';

const tabs: { id: PesquisaTab; label: string }[] = [
  { id: 'sobre', label: 'Sobre' },
  { id: 'politicas', label: 'Políticas Institucionais' },
  { id: 'pesquisadores', label: 'Pesquisadores' },
  { id: 'iniciacao', label: 'Iniciação Científica e Tecnológica' },
  { id: 'linhas', label: 'Linhas e Grupos' },
  { id: 'programas', label: 'Programas Acadêmicos' },
  { id: 'projetos-integradores', label: 'Projetos Integradores' },
  { id: 'inovacao', label: 'Inovação e Empreendedorismo' },
  { id: 'publicacoes', label: 'Publicações e PI' },
  { id: 'infraestrutura', label: 'Infraestrutura e Fomento' },
  { id: 'rede-impacto', label: 'Rede e Impacto' },
  { id: 'transparencia', label: 'Transparência Acadêmica' },
];

const tabIds = tabs.map((tab) => tab.id);

const researchers = [
  {
    name: 'Prof. Dr. Anderson Clayton Barreto Rodrigues',
    lattes: 'http://lattes.cnpq.br/3532538302321820',
    bio:
      'Doutor em Informática (UFAM), com formação em Processamento de Dados e experiência em tecnologia da informação e desenvolvimento de sistemas. Atua como analista de TI na Secretaria de Estado da Fazenda do Amazonas - SEFAZ-AM e docente na Faculdade de Tecnologia Senac Amazonas.',
  },
  {
    name: 'Prof. Me. Carlos Bruno Oliveira Lopes',
    lattes: 'http://lattes.cnpq.br/8195773427038880',
    orcid: 'https://orcid.org/0000-0003-0747-0999',
    bio:
      'Mestre em Ciência da Computação, doutorando em Informática e bacharel em Engenharia da Computação, com atuação em processamento de imagens e visão computacional. Possui experiência no desenvolvimento de soluções baseadas em modelos matemáticos e aplicações em fotografia computacional.',
  },
  {
    name: 'Prof. MSc. José Carlos da Silva Duarte Filho',
    lattes: 'http://lattes.cnpq.br/1129223641756414',
    orcid: 'https://orcid.org/0000-0001-5732-9729',
    bio:
      'Doutorando e Mestre em Informática (ICOMP/UFAM). Licenciado em Informática (UEA). Áreas: Educação em Computação, Eng. de Software, UX e Learning Sciences. Docente Senac AM e voluntário UEA/EST.',
  },
  {
    name: 'Prof. Me. Edwins Moura Ramires',
    lattes: 'http://lattes.cnpq.br/7067138841768507',
    bio:
      'Mestre em Engenharia de Processos (UFPA) e especialista em redes, telecomunicações e ensino superior, com atuação em cursos de TI e formação profissional no Senac Amazonas. Professor universitário e coordenador de TI na SES-AM, com experiência em inovação tecnológica, redes, segurança da informação e desenvolvimento de projetos educacionais e tecnológicos.',
  },
  {
    name: 'Profa. Dra. Samara Castro da Silva',
    lattes: 'http://lattes.cnpq.br/3377154555824021',
    orcid: 'https://orcid.org/0000-0002-8261-8239',
    bio:
      'Doutora em Turismo e Hospitalidade (UCS), com sólida formação em Administração, Engenharia de Produção e Direito, e mais de 25 anos de experiência em ensino, pesquisa e extensão. Docente do Senac Amazonas e líder no ecossistema de inovação, com atuação em empreendedorismo, mentoria de negócios e desenvolvimento de projetos tecnológicos e educacionais.',
  },
  {
    name: 'Profa. Me. Mayanna Emilia Tenório Vicente',
    lattes: 'https://lattes.cnpq.br/4401989421180573',
    orcid: 'https://orcid.org/0000-0002-4177-1595',
    bio:
      'Mestra em Ciências e Tecnologia para Recursos Amazônicos, com formação em Engenharia Química e atuação em pesquisa aplicada voltada à economia circular e aproveitamento de resíduos amazônicos. Docente da Faculdade Senac Amazonas, com experiência em processos laboratoriais, análises físico-químicas e soluções sustentáveis para o setor produtivo.',
  },
  {
    name: 'Prof. Me. Luiz Ricardo de Almeida e Silva',
    lattes: 'https://lattes.cnpq.br/1133717587650774',
    bio:
      'Mestrado em Educação (2003); Especialização em Educação e Trabalho (1992); Especialização em Neuropsicopedagogia e Novas Aprendizagens (2017).',
  },
  {
    name: 'Prof. Me. Nailson Andrade de Souza',
    lattes: 'http://lattes.cnpq.br/3328364467712901',
    orcid: 'https://orcid.org/0009-0007-2003-5664',
    bio:
      'Engenheiro, pesquisador e docente com 15+ anos na gestão do ensino técnico e superior. Mestre em Engenharia de Produção, MBA Executivo, especialista em Tecnologia Educacional (UFAM). Atuação em PD&I, portfólios de cursos, metodologias ativas e avaliação MEC.',
  },
  {
    name: 'Profa. Me. Nívea Consuêlo Carvalho dos Santos',
    lattes: 'http://lattes.cnpq.br/4219608679457725',
    orcid: 'https://orcid.org/0009-0009-3817-4800',
    bio:
      'Mestra em Ensino Tecnológico (IFAM), com formação multidisciplinar em Administração, TI e Inovação, atuando como coordenadora e docente na Faculdade de Tecnologia Senac Amazonas. Possui experiência em projetos educacionais, inovação e transformação digital, com atuação em consultorias, pesquisa e mentoria em desenvolvimento de soluções tecnológicas.',
  },
  {
    name: 'Prof. Me. Ramiro Hitotuzi Gomes',
    lattes: 'https://lattes.cnpq.br/4473774038395055',
    orcid: 'https://orcid.org/0000-0001-8127-6882',
    bio:
      'Mestre em Sociedade e Cultura na Amazônia (UFAM), com pesquisa voltada às práticas alimentares amazônicas sob perspectivas socioculturais. Docente e pesquisador, atua em projetos socioeducacionais e escreve sobre alimentação, cultura e sociedade no Jornal do Commercio do Amazonas.',
  },
  {
    name: 'Profa. Dra. Tatiana da Costa Jansen',
    lattes: 'http://lattes.cnpq.br/3945931267553518',
    orcid: 'https://orcid.org/0009-0006-6715-0275',
    bio:
      'Doutora em Biotecnologia (UFAM em parceria com USP/UNAERP), com mestrado em Genética e Evolução (UFSCar) e especialização em Biotecnologia, com foco em microrganismos e produção de bioativos. Possui formação também em Direito, com atuação interdisciplinar entre biotecnologia, pesquisa científica e aspectos legais da inovação.',
  },
  {
    name: 'Profa. Me. Yadira Pérez Cutiño',
    lattes: 'http://lattes.cnpq.br/3385687956857088',
    orcid: 'https://orcid.org/0000-0002-3994-7352',
    bio:
      'Mestrado em Administração, experiência internacional em docência, projetos de desenvolvimento territorial e atuação nas áreas econômica e administrativa. Atua na Faculdade Senac Amazonas em gestão acadêmica e pós-graduação, com experiência em projetos, auditoria, gestão educacional e ensino superior.',
  },
];

const researchGroups = [
  {
    title:
      'Educação Profissional, Inovação e Tecnologias em atividades do comércio de bens, serviços e turismo - Faculdade de Tecnologia Senac Amazonas (FATESE/AM)',
    lines: [
      {
        title: 'Linha 1 - Desenvolvimento Organizacional, Planejamento Estratégico e Internacionalização',
        description:
          'Esta linha tem como premissa identificar práticas e problemas recorrentes nas empresas dos diferentes setores econômicos da região de Manaus, as tecnologias de gestão adequadas ou desenvolver novas tecnologias para soluções de problemas organizacionais. Também busca mapear a influência das culturas nas práticas organizacionais, diferenciando-as por porte, setor econômico e atividade, com o intuito de investigar diferentes modelos e compreendendo-a como uma estratégia de gestão. Avalia a aplicação de diferentes técnicas de planejamento na gestão das atividades organizacionais, buscando identificar o grau de utilização dessas técnicas nas realidades empresariais.',
        objective:
          'Analisar e desenvolver práticas de gestão, planejamento estratégico e modelos organizacionais inovadores, considerando as especificidades do contexto amazônico, a competitividade empresarial e os processos de internacionalização, com foco na melhoria do desempenho organizacional.',
      },
      {
        title: 'Linha 2 - Sustentabilidade, Regionalidade e Meio Ambiente',
        description:
          'Estuda o emprego de materiais e tecnologias sustentáveis em projetos e sua interação com os indivíduos, seus reflexos e seus impactos na sociedade; investiga e aborda propostas, ações e projetos empregados em planejamento e em projetos em consonância com o ambiente, valorizando a interação com as comunidades locais. O estudo de recursos naturais provenientes da região, bem como o melhor aproveitamento do clima característico da região amazônica para o desenvolvimento de propostas que reflitam os princípios de cuidado com o meio ambiente e sustentabilidade, bem como sua interação com a sociedade local.',
        objective:
          'Investigar e desenvolver soluções sustentáveis que integrem o uso de recursos naturais, tecnologias e práticas socioambientais, considerando as especificidades da Amazônia e promovendo o equilíbrio entre desenvolvimento econômico, social e ambiental.',
      },
      {
        title: 'Linha 3 - Interfaces Tecnológicas',
        description:
          'Estuda a representação bi e tridimensional e o emprego de materiais e tecnologias nos sistemas e processos produtivos. Investiga tecnologias, dispositivos, suportes físicos e virtuais e equipamentos empregados no projeto de produtos e a sua interação com o usuário e aborda aspectos referentes a materiais, usabilidade, ergonomia, sistemas mecânicos e de produção.',
        objective:
          'Investigar e desenvolver soluções tecnológicas voltadas à interação entre usuários, sistemas e processos produtivos, abrangendo usabilidade, ergonomia, design, representação digital e integração de tecnologias em ambientes físicos e virtuais.',
      },
      {
        title: 'Linha 4 - Saúde, População e Sociedade',
        description:
          'A linha de pesquisa busca desenvolver estudos e pesquisas sobre os determinantes sociais do processo saúde e doença, enfatizando a compreensão das relações entre as condições de vida e os impactos sobre a saúde da população, bem como da organização das respostas sociais por meio dos sistemas, serviços e práticas de saúde alimentar implementadas nos diversos contextos sociais. Inclui, também, os estudos avaliativos de programas, intervenções, serviços de saúde alimentar ou outros aspectos da organização e gestão, cujas consequências afetam os coletivos humanos a eles relacionados.',
        objective:
          'Desenvolver estudos sobre os determinantes sociais da saúde e a organização de serviços e políticas públicas, com foco na melhoria da qualidade de vida, bem-estar e segurança alimentar da população.',
      },
      {
        title: 'Linha 5 - Cultura e Consumo',
        description:
          'Visa ampliar e adensar as discussões que envolvem o comportamento, aqui entendido como as ações que se estabelecem entre o indivíduo e o grupo, sejam conservadoras ou transformadoras da realidade, e sua relação com a cultura. Para tanto, pretende estabelecer as relações do comportamento e da cultura a partir dos temas do corpo, do consumo, das identidades e dos estilos de vida. O patrimônio cultural, as representações materiais e a construção simbólica da cultura.',
        objective:
          'Analisar as relações entre cultura, comportamento e consumo, investigando identidades, estilos de vida e práticas culturais, com foco nas dinâmicas sociais e econômicas e sua influência no mercado.',
      },
    ],
  },
  {
    title:
      'Pesquisa, Desenvolvimento e Inovação em atividades do comércio de bens, serviços e turismo - Senac Amazonas - Faculdade de Tecnologia Senac Amazonas (FATESE/AM)',
    lines: [
      {
        title: 'Linha 1 - Tecnologias da Informação e Inteligência Artificial',
        description:
          'Esta linha de pesquisa dedica-se ao desenvolvimento e aplicação de tecnologias digitais avançadas, com ênfase em Inteligência Artificial (IA), ciência de dados, automação e Internet das Coisas (IoT), voltadas à transformação digital das atividades do comércio de bens, serviços e turismo. Busca integrar soluções tecnológicas aos processos organizacionais, promovendo eficiência operacional, melhoria na tomada de decisão e inovação em produtos e serviços, alinhando-se às demandas do setor produtivo regional e às tendências da economia digital.',
        objective:
          'Desenvolver e aplicar soluções baseadas em tecnologias da informação e inteligência artificial para promover a inovação, a competitividade e a transformação digital das organizações do setor terciário.',
      },
      {
        title: 'Linha 2 - Biotecnologia',
        description:
          'Esta linha de pesquisa concentra-se no desenvolvimento de soluções biotecnológicas aplicadas ao aproveitamento sustentável da biodiversidade amazônica, com foco na geração de produtos e processos inovadores de alto valor agregado. Abrange estudos em bioeconomia, biotecnologia aplicada à saúde, cosméticos, alimentos e meio ambiente, promovendo a integração entre ciência, tecnologia e sustentabilidade. Busca contribuir para o desenvolvimento regional por meio da inovação baseada em recursos naturais, respeitando princípios ambientais e sociais.',
        objective:
          'Desenvolver soluções biotecnológicas inovadoras, sustentáveis e aplicadas ao uso da biodiversidade amazônica, promovendo o desenvolvimento econômico e tecnológico regional.',
      },
      {
        title: 'Linha 3 - Tecnologias para o Varejo e Experiência do Cliente',
        description:
          'Esta linha investiga e desenvolve soluções tecnológicas e estratégias inovadoras voltadas à modernização do varejo e à melhoria da experiência do cliente. Envolve o uso de ferramentas digitais, plataformas de e-commerce, sistemas omnichannel, análise de comportamento do consumidor e tecnologias emergentes para personalização de serviços. Busca fortalecer a competitividade das empresas do setor terciário por meio da integração entre tecnologia, marketing e gestão, promovendo experiências mais eficientes, personalizadas e centradas no usuário.',
        objective:
          'Desenvolver soluções e modelos inovadores que integrem tecnologia e gestão para aprimorar a experiência do cliente e aumentar a competitividade do varejo e dos serviços.',
      },
      {
        title: 'Linha 4 - Gastronomia e Alimentação do Futuro',
        description:
          'Esta linha de pesquisa aborda tendências emergentes na gastronomia e na alimentação, com foco em inovação, sustentabilidade, tecnologia de alimentos e valorização da cultura alimentar amazônica. Envolve estudos sobre novos modelos de produção e consumo, alimentos funcionais, segurança alimentar, gastronomia sustentável e uso de ingredientes regionais. Também contempla a integração entre ciência, tecnologia e práticas gastronômicas, contribuindo para o desenvolvimento de soluções inovadoras no setor de alimentação e hospitalidade.',
        objective:
          'Investigar e desenvolver soluções inovadoras para o setor de alimentação, integrando tecnologia, sustentabilidade e valorização da cultura alimentar regional.',
      },
    ],
  },
];

const innovationItems = [
  {
    title: 'ICT-Senac',
    description: 'Instituição Científica, Tecnológica e de Inovação voltada à articulação de projetos e soluções aplicadas.',
  },
  {
    title: 'Incubadora',
    description: 'Ambiente de apoio à maturação de ideias, negócios e soluções desenvolvidas pela comunidade acadêmica.',
  },
  {
    title: 'Hub de Inovação',
    description: 'Espaço de conexão entre estudantes, docentes, empresas e parceiros para desenvolvimento de iniciativas.',
  },
  {
    title: 'Banco de Ideias e Desafios',
    description: 'Base para registro de oportunidades, problemas reais e propostas de solução para projetos aplicados.',
  },
];

const impactItems = [
  {
    title: 'Parcerias e Convênios',
    description: 'Relações institucionais para ampliar cooperação, projetos, oportunidades e atuação territorial.',
  },
  {
    title: 'Premiações e Cases',
    description: 'Registro de reconhecimentos, resultados relevantes e iniciativas de destaque da comunidade acadêmica.',
  },
  {
    title: 'Impacto Social e Econômico',
    description: 'Indicadores e evidências de contribuição para formação, mercado, comunidade e desenvolvimento local.',
  },
  {
    title: 'Economia Tecnológica e Social',
    description: 'Acompanhamento de tendências, oportunidades e resultados gerados por projetos de inovação aplicada.',
  },
];

const SectionHeading: React.FC<{ children: React.ReactNode; eyebrow?: string }> = ({ children, eyebrow }) => (
  <Box sx={{ mb: { xs: 2.4, md: 3 } }}>
    {eyebrow ? (
      <Typography variant="overline" sx={{ color: 'secondary.main', fontWeight: 800, letterSpacing: 1 }}>
        {eyebrow}
      </Typography>
    ) : null}
    <Typography
      variant="h5"
      sx={{
        color: 'primary.main',
        fontWeight: 800,
        lineHeight: 1.25,
        fontSize: { xs: '1.28rem', sm: '1.45rem', md: '1.5rem' },
      }}
    >
      {children}
    </Typography>
  </Box>
);

const InfoCard: React.FC<{
  icon: React.ReactNode;
  title: string;
  description: string;
}> = ({ icon, title, description }) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderColor: alpha(theme.palette.primary.main, 0.1),
        boxShadow: '0 10px 26px rgba(15, 23, 42, 0.05)',
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
        <Stack direction="row" spacing={1.4} alignItems="flex-start">
          <Box
            sx={{
              width: 38,
              height: 38,
              flex: '0 0 auto',
              borderRadius: 1.5,
              display: 'grid',
              placeItems: 'center',
              color: 'secondary.main',
              bgcolor: alpha(theme.palette.secondary.main, 0.1),
            }}
          >
            {icon}
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ color: 'primary.main', fontWeight: 800, fontSize: { xs: '0.98rem', md: '1rem' } }}
            >
              {title}
            </Typography>
            <Typography sx={{ mt: 0.8, color: 'text.secondary', lineHeight: 1.7 }}>{description}</Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

const ResearcherCard: React.FC<{ name: string; lattes: string; bio: string; orcid?: string }> = ({
  name,
  lattes,
  bio,
  orcid,
}) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderColor: alpha(theme.palette.primary.main, 0.1),
        boxShadow: '0 10px 26px rgba(15, 23, 42, 0.05)',
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
        <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 800, fontSize: '1rem' }}>
          {name}
        </Typography>
        <Stack direction="row" spacing={1.2} flexWrap="wrap" useFlexGap sx={{ mt: 0.4 }}>
          <Button
            size="small"
            variant="text"
            color="primary"
            endIcon={<Launch fontSize="small" />}
            href={lattes}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ px: 0, fontWeight: 800 }}
          >
            Currículo Lattes
          </Button>
          {orcid ? (
            <Button
              size="small"
              variant="text"
              color="secondary"
              endIcon={<Launch fontSize="small" />}
              href={orcid}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ px: 0, fontWeight: 800 }}
            >
              Orcid
            </Button>
          ) : null}
        </Stack>
        <Typography sx={{ mt: 1.4, color: 'text.secondary', lineHeight: 1.75 }}>{bio}</Typography>
      </CardContent>
    </Card>
  );
};

const CompactAccordion: React.FC<{ title: string; children: React.ReactNode; defaultExpanded?: boolean }> = ({
  title,
  children,
  defaultExpanded = false,
}) => (
  <Accordion
    defaultExpanded={defaultExpanded}
    disableGutters
    sx={{ border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}
  >
    <AccordionSummary expandIcon={<ExpandMore />} sx={{ px: { xs: 1.6, md: 2 } }}>
      <Typography sx={{ color: 'primary.main', fontWeight: 800, lineHeight: 1.35 }}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ px: { xs: 1.6, md: 2 }, pt: 0 }}>
      {typeof children === 'string' ? (
        <Typography sx={{ color: 'text.secondary', lineHeight: 1.75 }}>{children}</Typography>
      ) : (
        children
      )}
    </AccordionDetails>
  </Accordion>
);

const PesquisaInovacao: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [activeTab, setActiveTab] = useState<PesquisaTab>('sobre');

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (tabIds.includes(hash as PesquisaTab)) {
      setActiveTab(hash as PesquisaTab);
    }
  }, [location.hash]);

  const selectTab = (tab: PesquisaTab) => {
    setActiveTab(tab);
    window.history.replaceState(null, '', `#${tab}`);
  };

  const underline = {
    content: '""',
    position: 'absolute' as const,
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: 0,
    width: { xs: 150, md: 240 },
    height: 4,
    borderRadius: 99,
    backgroundColor: theme.palette.secondary.main,
  };

  const renderProjectsGrid = () => (
    <Grid container spacing={2.2}>
      {pdiProjects.map((project) => (
        <Grid item xs={12} sm={6} lg={4} key={project.title}>
          <Card
            variant="outlined"
            sx={{
              height: '100%',
              borderColor: alpha(theme.palette.primary.main, 0.1),
              boxShadow: '0 10px 28px rgba(15, 23, 42, 0.055)',
            }}
          >
            <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.3, height: '100%', p: 2.3 }}>
              <Typography variant="overline" sx={{ color: 'secondary.main', fontWeight: 800, letterSpacing: 0.8 }}>
                Projeto
              </Typography>
              <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 800, fontSize: '1rem', lineHeight: 1.35 }}>
                {project.title}
              </Typography>
              <Typography sx={{ color: 'text.secondary', lineHeight: 1.65 }}>{project.summary}</Typography>
              <Typography variant="body2" sx={{ mt: 'auto', color: 'text.secondary', fontWeight: 700 }}>
                {project.period}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'sobre':
        return (
          <>
            <SectionHeading eyebrow="Pesquisa aplicada">Sobre</SectionHeading>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85, textAlign: 'justify' }}>
              A área de Pesquisa e Inovação da Faculdade de Tecnologia Senac Amazonas articula projetos acadêmicos,
              desenvolvimento aplicado e aproximação com demandas reais do comércio, serviços, turismo, tecnologia e
              comunidade. O espaço reúne iniciativas de PD&I, projetos integradores, inovação, empreendedorismo, publicações
              e ações voltadas à transformação institucional.
            </Typography>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85, textAlign: 'justify' }}>
              A proposta desta página é organizar a produção acadêmica e os ambientes de inovação em uma navegação única,
              facilitando consulta, atualização e acesso às iniciativas estratégicas da instituição.
            </Typography>
            <Grid container spacing={2.2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={4}>
                <InfoCard icon={<ScienceOutlined />} title="PD&I" description="Pesquisa, desenvolvimento e inovação com base em projetos aplicados." />
              </Grid>
              <Grid item xs={12} md={4}>
                <InfoCard icon={<LightbulbOutlined />} title="Inovação aplicada" description="Soluções práticas conectadas aos desafios do mercado e da comunidade." />
              </Grid>
              <Grid item xs={12} md={4}>
                <InfoCard icon={<Hub />} title="Ecossistema" description="Integração entre ensino, pesquisa, extensão, empresas e parceiros." />
              </Grid>
            </Grid>
          </>
        );

      case 'politicas':
        return (
          <>
            <SectionHeading eyebrow="Diretrizes">Políticas Institucionais de Pesquisa e Inovação</SectionHeading>
            <Grid container spacing={2.2} sx={{ mb: 3 }}>
              {[
                {
                  label: 'Diretrizes de Inovação',
                  href: 'http://www.extranet.senac.br/diretrizes-ia/index.html',
                },
                {
                  label: 'Diretrizes de Inteligência Artificial',
                  href: 'http://www.extranet.senac.br/diretrizes-ia/index.html',
                },
                {
                  label: 'Portal Extranet para demais políticas e documentos',
                  href: 'http://www.extranet.senac.br/extranet/documentos.html',
                },
              ].map((item) => (
                <Grid item xs={12} md={4} key={item.label}>
                  <Card variant="outlined" sx={{ height: '100%', borderColor: alpha(theme.palette.primary.main, 0.1) }}>
                    <CardContent sx={{ p: 2.3 }}>
                      <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>{item.label}</Typography>
                      <Button
                        size="small"
                        variant="text"
                        endIcon={<Launch fontSize="small" />}
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ px: 0, mt: 1, fontWeight: 800 }}
                      >
                        Acessar
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Stack spacing={1.2}>
              <CompactAccordion title="Ética em Pesquisa" defaultExpanded>
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.75 }}>
                  Orientações para desenvolvimento responsável de pesquisas, proteção de participantes e integridade acadêmica.
                </Typography>
              </CompactAccordion>
              <CompactAccordion title="Comitê de Ética em Pesquisa">
                <Stack spacing={1.6}>
                  {[
                    'O Comitê de Ética em Pesquisa (CEP) é um colegiado interdisciplinar e independente, responsável por analisar e acompanhar os aspectos éticos de pesquisas que envolvem seres humanos, assegurando a proteção dos participantes e a integridade das atividades científicas.',
                    'De acordo com as diretrizes da Comissão Nacional de Ética em Pesquisa (CONEP), os CEPs têm como finalidade garantir que os estudos sejam conduzidos com respeito à dignidade, aos direitos e ao bem-estar dos participantes, contribuindo para o desenvolvimento da pesquisa dentro de padrões éticos reconhecidos nacionalmente.',
                    'No âmbito da Faculdade de Tecnologia Senac Amazonas, as pesquisas acadêmicas e aplicadas que envolvem seres humanos - de forma direta ou indireta, como entrevistas, questionários, uso de dados pessoais ou testes - devem observar rigorosamente os princípios éticos estabelecidos pela legislação vigente.',
                    'O Comitê de Ética em Pesquisa da Faculdade Senac Amazonas tem como objetivo fortalecer a governança científica, apoiar pesquisadores e garantir a conformidade ética das pesquisas desenvolvidas no âmbito institucional.',
                    'Os pesquisadores deverão buscar a submissão de seus projetos em Comitês de Ética em Pesquisa devidamente credenciados junto à CONEP, quando aplicável.',
                    'A Faculdade de Tecnologia Senac Amazonas reforça seu compromisso com a ética, a responsabilidade social e a qualidade científica, promovendo uma cultura de pesquisa responsável e alinhada às melhores práticas nacionais e internacionais.',
                  ].map((paragraph) => (
                    <Typography key={paragraph} sx={{ color: 'text.secondary', lineHeight: 1.75, textAlign: 'justify' }}>
                      {paragraph}
                    </Typography>
                  ))}
                </Stack>
              </CompactAccordion>
              <CompactAccordion title="Comissão Nacional de Ética em Pesquisa - CONEP">
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.75 }}>
                  Diretamente ligada ao Conselho Nacional de Saúde - CNS, tem como principal atribuição a avaliação dos
                  aspectos éticos das pesquisas que envolvem seres humanos no Brasil.
                </Typography>
                <MLink
                  href="https://www.gov.br/conselho-nacional-de-saude/pt-br/camaras-tecnicas-e-comissoes/conep"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                  sx={{ display: 'inline-flex', mt: 1.2, fontWeight: 800 }}
                >
                  Acessar CONEP
                </MLink>
              </CompactAccordion>
              <CompactAccordion title="Documentos e Diretrizes Senac">
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.75 }}>
                  No link abaixo, você acessa documentos relevantes para orientação institucional, incluindo:
                </Typography>
                <Stack component="ul" spacing={0.7} sx={{ mt: 1.2, pl: 2.4, color: 'text.secondary' }}>
                  {[
                    'Governança e Integridade no Senac: conceitos e princípios',
                    'Código Nacional de Tecnologia da Informação (CODETI)',
                    'Diretrizes de Inovação',
                    'Diretrizes de Inteligência Artificial',
                    'Repositório sobre Diversidade e Inclusão',
                  ].map((item) => (
                    <Typography component="li" key={item} sx={{ lineHeight: 1.6 }}>
                      {item}
                    </Typography>
                  ))}
                </Stack>
                <Stack spacing={0.8} sx={{ mt: 1.6 }}>
                  <MLink
                    href="http://www.extranet.senac.br/extranet/documentos.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{ fontWeight: 800 }}
                  >
                    Acessar documentos da Extranet
                  </MLink>
                  <MLink
                    href="https://www3.sp.senac.br/hotsites/campus_santoamaro/cd/arquivos/pesquisa/cep_final_1.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{ fontWeight: 800 }}
                  >
                    Manual Prático Comitê de Ética em Pesquisa, elaborado pelo Senac/SP
                  </MLink>
                </Stack>
              </CompactAccordion>
            </Stack>
          </>
        );

      case 'pesquisadores':
        return (
          <>
            <SectionHeading eyebrow="Corpo técnico">Pesquisadores</SectionHeading>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85 }}>
              Docentes e profissionais vinculados às ações de pesquisa, desenvolvimento, inovação e projetos aplicados.
            </Typography>
            <Grid container spacing={2.2}>
              {researchers.map((researcher) => (
                <Grid item xs={12} md={6} key={researcher.name}>
                  <ResearcherCard
                    name={researcher.name}
                    lattes={researcher.lattes}
                    bio={researcher.bio}
                    orcid={researcher.orcid}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        );

      case 'iniciacao':
        return (
          <>
            <SectionHeading eyebrow="Formação científica">Iniciação Científica e Tecnológica</SectionHeading>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85, textAlign: 'justify' }}>
              A Iniciação Científica e Tecnológica insere o estudante no universo da pesquisa acadêmica e aplicada,
              estimulando pensamento crítico, investigação, criatividade e desenvolvimento de soluções conectadas aos
              desafios da sociedade e do setor produtivo.
            </Typography>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85, textAlign: 'justify' }}>
              As ações são vinculadas às linhas e grupos de pesquisa da Faculdade de Tecnologia Senac Amazonas e fortalecem
              a integração entre ensino, pesquisa, inovação, projetos integradores e desenvolvimento tecnológico.
            </Typography>
            <Grid container spacing={2.2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={4}>
                <InfoCard
                  icon={<ScienceOutlined />}
                  title="Pesquisa aplicada"
                  description="Apoio ao desenvolvimento de projetos acadêmicos com base em problemas reais e oportunidades de inovação."
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InfoCard
                  icon={<LightbulbOutlined />}
                  title="Desenvolvimento tecnológico"
                  description="Estímulo à criação, experimentação e validação de soluções tecnológicas e metodológicas."
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InfoCard
                  icon={<Hub />}
                  title="Integração acadêmica"
                  description="Conexão entre estudantes, docentes, pesquisadores, projetos integradores e demandas institucionais."
                />
              </Grid>
            </Grid>
          </>
        );

      case 'linhas':
        return (
          <>
            <SectionHeading eyebrow="Eixos de atuação">Grupos e Linhas de Pesquisa</SectionHeading>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85 }}>
              A Faculdade de Tecnologia Senac Amazonas conta com grupos de pesquisa que desenvolvem estudos e soluções
              voltadas à inovação, educação profissional e ao fortalecimento das atividades do comércio de bens, serviços e
              turismo. Esses grupos estão organizados em diferentes linhas de pesquisa, que abrangem áreas estratégicas como
              gestão, tecnologia, sustentabilidade, cultura, saúde e desenvolvimento regional, contribuindo para a produção
              de conhecimento aplicado e para a geração de soluções alinhadas às demandas do mercado e da sociedade.
            </Typography>
            <Stack spacing={2}>
              {researchGroups.map((group) => (
                <Box key={group.title}>
                  <Typography variant="overline" sx={{ color: 'secondary.main', fontWeight: 800 }}>
                    Grupo de Pesquisa
                  </Typography>
                  <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 800, lineHeight: 1.35, mb: 1.4 }}>
                    {group.title}
                  </Typography>
                  <Stack spacing={1.2}>
                    {group.lines.map((line, index) => (
                      <CompactAccordion key={line.title} title={line.title} defaultExpanded={index === 0}>
                        <Stack spacing={1.2}>
                          <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, textAlign: 'justify' }}>
                            <Box component="span" sx={{ color: 'primary.main', fontWeight: 800 }}>
                              Descrição:{' '}
                            </Box>
                            {line.description}
                          </Typography>
                          <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, textAlign: 'justify' }}>
                            <Box component="span" sx={{ color: 'primary.main', fontWeight: 800 }}>
                              Objetivo:{' '}
                            </Box>
                            {line.objective}
                          </Typography>
                        </Stack>
                      </CompactAccordion>
                    ))}
                  </Stack>
                </Box>
              ))}
            </Stack>
          </>
        );

      case 'programas':
        return (
          <>
            <SectionHeading eyebrow="Formação">Programas Acadêmicos para Graduação</SectionHeading>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85, textAlign: 'justify' }}>
              A Faculdade de Tecnologia Senac Amazonas não possui, no momento, programas internos de concessão de bolsas
              para os cursos de graduação. No entanto, orienta e incentiva seus estudantes a participarem de programas
              externos que ampliam o acesso ao ensino superior e oferecem oportunidades de gratuidade, financiamento e
              apoio acadêmico.
            </Typography>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85 }}>
              Neste espaço, você encontra algumas das principais opções disponíveis, organizadas por tipo de oportunidade:
            </Typography>

            <Stack spacing={1.2}>
              <CompactAccordion title="Programas de Acesso à Graduação" defaultExpanded>
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, mb: 1.5 }}>
                  Programas que facilitam o ingresso no ensino superior por meio de seleção, bolsas ou financiamento:
                </Typography>
                <Stack spacing={1.6}>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Portal Único de Acesso ao Ensino Superior</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      Reúne programas do Governo Federal: Sisu - Sistema de Seleção Unificada, Prouni - Programa
                      Universidade para Todos e Fies - Financiamento Estudantil.
                    </Typography>
                    <MLink href="https://acessounico.mec.gov.br/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                      Acessar
                    </MLink>
                  </Box>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Bolsa Universidade</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      Para se inscrever nos programas socioeducacionais da Prefeitura de Manaus: Programa Bolsa
                      Universidade (PBU), Programa Bolsa Pós-Graduação (PBPG) e Programa Bolsa Idiomas (PBI).
                    </Typography>
                    <MLink href="https://portalespi.manaus.am.gov.br/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                      Acessar
                    </MLink>
                  </Box>
                </Stack>
              </CompactAccordion>

              <CompactAccordion title="Programas de Qualificação e Formação Profissional">
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, mb: 1.5 }}>
                  Programas voltados à capacitação e desenvolvimento profissional:
                </Typography>
                <Stack spacing={1.6}>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Programa Senac de Gratuidade (PSG)</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      Oferece vagas gratuitas em cursos de educação profissional, contribuindo para a qualificação e
                      inserção no mercado de trabalho.
                    </Typography>
                    <MLink href="https://www.ead.senac.br/gratuito/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                      Acessar
                    </MLink>
                  </Box>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Cisco Networking Academy</Typography>
                    <MLink href="https://www.netacad.com/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                      Acessar
                    </MLink>
                  </Box>
                </Stack>
              </CompactAccordion>

              <CompactAccordion title="Programas de Bolsas de Pesquisa e Inovação">
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, mb: 1.5 }}>
                  Programas que apoiam estudantes em atividades de pesquisa, inovação e desenvolvimento tecnológico:
                </Typography>
                <Stack spacing={1.6}>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>FAPEAM</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      A Fundação de Amparo à Pesquisa do Estado do Amazonas oferece bolsas e auxílios para estudantes
                      vinculados a projetos de pesquisa e inovação.
                    </Typography>
                    <MLink href="https://www.fapeam.am.gov.br/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                      Acessar
                    </MLink>
                  </Box>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>CNPq</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      O Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) oferece bolsas de iniciação
                      científica e apoio a projetos acadêmicos em diversas áreas do conhecimento. Os estudantes podem
                      acessar editais e oportunidades por meio da Plataforma Carlos Chagas.
                    </Typography>
                    <Stack direction="row" spacing={1.4} flexWrap="wrap" useFlexGap>
                      <MLink href="https://www.gov.br/cnpq/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                        Acessar CNPq
                      </MLink>
                      <MLink href="https://carloschagas.cnpq.br/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                        Plataforma de bolsas
                      </MLink>
                    </Stack>
                  </Box>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Bolsa de Pesquisa da Microsoft</Typography>
                    <MLink
                      href="https://www.microsoft.com/en-us/research/academic-programs/?culture=en-us&country=us"
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                      sx={{ fontWeight: 800 }}
                    >
                      Acessar
                    </MLink>
                  </Box>
                </Stack>
              </CompactAccordion>

              <CompactAccordion title="Programas de Desenvolvimento Acadêmico e Internacional">
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, mb: 1.5 }}>
                  Programas voltados ao crescimento acadêmico, intercâmbio e formação complementar:
                </Typography>
                <Stack spacing={1.6}>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Santander Universidades</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      Oferece bolsas, cursos, intercâmbio e oportunidades de desenvolvimento acadêmico e profissional.
                    </Typography>
                    <MLink href="https://www.becas-santander.com/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                      Acessar
                    </MLink>
                  </Box>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Fundação Estudar</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      Oferece bolsas de estudo e programas de desenvolvimento para estudantes com alto desempenho acadêmico.
                    </Typography>
                    <MLink href="https://www.estudar.org.br/" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 800 }}>
                      Acessar
                    </MLink>
                  </Box>
                  <Box>
                    <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Microsoft</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                      Disponibiliza programas acadêmicos, oportunidades de capacitação e iniciativas voltadas ao
                      desenvolvimento de estudantes e pesquisadores.
                    </Typography>
                    <MLink
                      href="https://www.microsoft.com/en-us/research/academic-programs/?culture=en-us&country=us"
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                      sx={{ fontWeight: 800 }}
                    >
                      Acessar
                    </MLink>
                  </Box>
                </Stack>
              </CompactAccordion>

              <Card variant="outlined" sx={{ borderColor: alpha(theme.palette.primary.main, 0.1) }}>
                <CardContent sx={{ p: 2.3 }}>
                  <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Fique atento</Typography>
                  <Typography sx={{ mt: 0.8, color: 'text.secondary', lineHeight: 1.75 }}>
                    Recomendamos que os estudantes acompanhem regularmente os prazos, editais e critérios de cada programa,
                    pois as oportunidades são periódicas e possuem requisitos específicos.
                  </Typography>
                </CardContent>
              </Card>
            </Stack>
          </>
        );

      case 'projetos-integradores':
        return (
          <>
            <SectionHeading eyebrow="PD&I">Projetos Integradores</SectionHeading>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85 }}>
              Relação consolidada dos projetos disponíveis na base atual de Pesquisa e Inovação. Os projetos ficam
              organizados em cards compactos dentro desta aba, sem ocupar o menu lateral individualmente.
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 3 }}>
              <Chip label={`${pdiProjects.length} projetos catalogados`} color="primary" variant="outlined" />
              <Chip label="Base pronta para atualização" color="secondary" variant="outlined" />
            </Stack>
            {renderProjectsGrid()}
          </>
        );

      case 'inovacao':
        return (
          <>
            <SectionHeading eyebrow="Ambientes">Inovação e Empreendedorismo</SectionHeading>
            <Grid container spacing={2.2}>
              {innovationItems.map((item) => (
                <Grid item xs={12} md={6} key={item.title}>
                  <InfoCard icon={<AutoAwesome />} title={item.title} description={item.description} />
                </Grid>
              ))}
            </Grid>
            <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main', fontWeight: 800 }}>
              Soluções Inovadoras para Empresas
            </Typography>
            <Grid container spacing={2.2}>
              {consultingOffers.map((offer) => (
                <Grid item xs={12} md={4} key={offer.title}>
                  <InfoCard icon={<BusinessCenter />} title={offer.title} description={offer.description} />
                </Grid>
              ))}
            </Grid>
            <Button
              component={RouterLink}
              to="/pesquisa-inovacao/solucoes-inovadoras-para-empresas"
              variant="contained"
              color="secondary"
              sx={{ mt: 3, fontWeight: 800 }}
            >
              Acessar soluções para empresas
            </Button>
          </>
        );

      case 'publicacoes':
        return (
          <>
            <SectionHeading eyebrow="Produção">Publicações e Propriedade Intelectual</SectionHeading>
            <Grid container spacing={2.2}>
              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<Article />}
                  title="Publicações"
                  description="Espaço para registro de artigos, relatórios, materiais técnicos e produções acadêmicas vinculadas às linhas de pesquisa."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<WorkspacePremium />}
                  title="Patentes e Propriedade Intelectual"
                  description="Orientação e acompanhamento de registros, proteção de soluções e ativos de propriedade intelectual."
                />
              </Grid>
            </Grid>
          </>
        );

      case 'infraestrutura':
        return (
          <>
            <SectionHeading eyebrow="Apoio">Infraestrutura e Fomento</SectionHeading>
            <Grid container spacing={2.2}>
              <Grid item xs={12} md={6}>
                <InfoCard icon={<ScienceOutlined />} title="Laboratórios e Infraestrutura" description="Ambientes de apoio ao desenvolvimento de práticas, prototipagem, estudos e projetos aplicados." />
              </Grid>
              <Grid item xs={12} md={6}>
                <InfoCard icon={<Insights />} title="Editais e Oportunidades" description="Chamadas, oportunidades internas e externas, editais e ações de estímulo à pesquisa e inovação." />
              </Grid>
              <Grid item xs={12}>
                <InfoCard icon={<ManageSearch />} title="Captação de Recursos e Fomento" description="Apoio à busca de recursos, parcerias, editais e mecanismos de financiamento para projetos acadêmicos e tecnológicos." />
              </Grid>
            </Grid>
          </>
        );

      case 'rede-impacto':
        return (
          <>
            <SectionHeading eyebrow="Resultados">Rede e Impacto</SectionHeading>
            <Grid container spacing={2.2}>
              {impactItems.map((item) => (
                <Grid item xs={12} md={6} key={item.title}>
                  <InfoCard icon={<Public />} title={item.title} description={item.description} />
                </Grid>
              ))}
            </Grid>
            <Card variant="outlined" sx={{ mt: 2.2, borderColor: alpha(theme.palette.primary.main, 0.1) }}>
              <CardContent sx={{ p: 2.4 }}>
                <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>Eventos e Agenda</Typography>
                <Typography sx={{ mt: 0.8, color: 'text.secondary', lineHeight: 1.7 }}>
                  Espaço para divulgação de eventos científicos, encontros, bancas, apresentações e atividades relacionadas
                  à pesquisa e inovação.
                </Typography>
              </CardContent>
            </Card>
          </>
        );

      case 'transparencia':
        return (
          <>
            <SectionHeading eyebrow="Governança">Portal de Transparência Acadêmica</SectionHeading>
            <Typography paragraph sx={{ color: 'text.secondary', lineHeight: 1.85 }}>
              Área destinada à organização de documentos, resultados, indicadores e informações públicas relacionadas às
              ações acadêmicas de pesquisa, desenvolvimento e inovação.
            </Typography>
            <Grid container spacing={2.2}>
              <Grid item xs={12} md={4}>
                <InfoCard icon={<School />} title="Indicadores" description="Dados de acompanhamento da produção acadêmica e participação institucional." />
              </Grid>
              <Grid item xs={12} md={4}>
                <InfoCard icon={<AccountTree />} title="Projetos" description="Registros consolidados de projetos, linhas, grupos e iniciativas vinculadas." />
              </Grid>
              <Grid item xs={12} md={4}>
                <InfoCard icon={<Article />} title="Documentos" description="Materiais institucionais, relatórios, políticas e referências para consulta." />
              </Grid>
            </Grid>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Box sx={{ p: { xs: 1.5, sm: 2.5, md: 6, lg: 8 } }}>
      <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 4 } }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 800,
            letterSpacing: 0.2,
            display: 'inline-block',
            pb: 1.5,
            position: 'relative',
            color: 'primary.main',
            fontSize: { xs: '1.7rem', sm: '2rem', md: '2.125rem' },
            '&::after': underline,
          }}
        >
          Pesquisa e Inovação
        </Typography>
      </Box>

      <Grid container spacing={{ xs: 2.5, md: 3 }}>
        <Grid item xs={12} md={2.7} lg={2.5}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'row', md: 'column' },
              gap: { xs: 0.8, md: 0.9 },
              overflowX: { xs: 'auto', md: 'visible' },
              pb: { xs: 1, md: 0 },
              mx: { xs: -1.5, sm: -2.5, md: 0 },
              px: { xs: 1.5, sm: 2.5, md: 0 },
              scrollSnapType: { xs: 'x mandatory', md: 'none' },
              WebkitOverflowScrolling: 'touch',
              position: { md: 'sticky' },
              top: { md: 92 },
            }}
          >
            {tabs.map((tab) => {
              const selected = activeTab === tab.id;

              return (
                <Button
                  key={tab.id}
                  variant={selected ? 'contained' : 'outlined'}
                  onClick={() => selectTab(tab.id)}
                  fullWidth={!isMobile}
                  sx={{
                    justifyContent: { xs: 'center', md: 'flex-start' },
                    minWidth: { xs: 142, sm: 168, md: 'auto' },
                    py: 0.95,
                    px: 1.35,
                    textAlign: 'left',
                    textTransform: 'none',
                    fontWeight: 800,
                    fontSize: { xs: '0.78rem', sm: '0.86rem' },
                    lineHeight: 1.25,
                    scrollSnapAlign: 'start',
                    borderRadius: 1.4,
                    boxShadow: selected ? '0 8px 18px rgba(0, 58, 112, 0.16)' : 'none',
                    bgcolor: selected ? 'primary.main' : '#fff',
                  }}
                >
                  {tab.label}
                </Button>
              );
            })}
          </Box>
        </Grid>

        <Grid item xs={12} md={9.3} lg={9.5}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 2.5, md: 4 },
              borderRadius: { xs: 1.5, md: 2 },
              border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
              boxShadow: '0 18px 42px rgba(15, 23, 42, 0.07)',
              bgcolor: '#fff',
              minHeight: { xs: 'auto', md: 480 },
            }}
          >
            {renderContent()}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PesquisaInovacao;
